export enum FeatureFlag {
	EnableResourceFreezing = 'enable_resource_freezing',
	EnableAutomationPermissions = 'enable_automation_permissions',
	UsePagedQueryByTags = 'use_paged_query_by_tags',
	DisableLegacyRoles = 'disable_legacy_roles',
	EnableProjectAsSolution = 'work_management',
}
